<div *ngIf="user" class="main-wrapper">
    <div class="top-bg-wrapper">
        <div class="lay-over"></div>
        <app-image-view
            [paddingBottom]="'450px'"
            [media_id]="(resource.medias?.background?.length && resource.medias?.background[0]) || resource.media$"
        >
        </app-image-view>
    </div>
    <div class="main-content-wrapper" fxLayout="row" fxLayoutAlign="space-between start">
        <div class="right-part" fxLayout="column" fxLayoutGap="1.2em">
            <div class="upper-part" fxLayoutAlign="space-between start" fxLayout="row">
                <div class="action-items-wrapper">
                    <div
                        class="main-action-wrapper"
                        fxLayoutGap="0.4em"
                        fxLayout="column"
                        fxLayoutAlign="space-between start"
                    >
                        <ng-container *ngIf="resource.opportunity_id">
                            <button
                                class="take"
                                [disabled]="!checkCanJoiEvent()"
                                (click)="checkCanJoiEvent() && joinEventDireclty()"
                                mat-raised-button
                            >
                                <ng-container *ngIf="!checkCanJoiEvent()">
                                    <mat-icon>event_available</mat-icon>
                                    <span i18n>Joined</span>
                                </ng-container>
                                <ng-container *ngIf="checkCanJoiEvent()">
                                    <mat-icon>event_available</mat-icon>
                                    <span i18n>Join</span>
                                </ng-container>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="!resource.opportunity_id">
                            <button
                                *ngIf="getResourceAvailablity(resource) | async; else shareLoadTemp; let eventJoin"
                                (click)="takeEvent(resource, user, eventJoin)"
                                class="take"
                                mat-raised-button
                            >
                                <mat-icon>{{ eventJoin.icon }}</mat-icon>
                                <span>{{ eventJoin.label }}</span>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="lower-part" fxLayoutAlign="space-between start" fxLayoutGap="2em" fxLayout="row">
                <div class="lower-left"></div>
                <div class="lower-right">
                    <div class="res-small-details">
                        <!-- Inject lower small details here -->

                        <div class="details-elem">
                            <div class="pre">
                                <mat-icon>account_circle</mat-icon>
                                <span i18n>Created by </span>
                            </div>
                            <span class="normal"
                                >{{ resource.author_name || $any(resource.author$ | async)?.name }}
                            </span>
                        </div>
                        <div *ngIf="!!resource.educators?.length" class="details-elem">
                            <div class="pre">
                                <mat-icon>engineering</mat-icon>
                                <span i18n="@@educators">Educators</span>
                            </div>
                            <span class="normal">
                                <ng-container
                                    [ngTemplateOutlet]="staff"
                                    [ngTemplateOutletContext]="{
                                        staff: resource.educators,
                                        icon: 'engineering'
                                    }"
                                ></ng-container>
                            </span>
                        </div>
                        <div *ngIf="!!resource.hosts?.length" class="details-elem">
                            <div class="pre">
                                <mat-icon>record_voice_over</mat-icon>
                                <span i18n="@@hosts">Hosts</span>
                            </div>
                            <span class="normal">
                                <ng-container
                                    [ngTemplateOutlet]="staff"
                                    [ngTemplateOutletContext]="{
                                        staff: resource.hosts,
                                        icon: 'record_voice_over'
                                    }"
                                ></ng-container>
                            </span>
                        </div>
                        <div *ngIf="resource.organizers?.length" class="details-elem">
                            <div class="pre">
                                <mat-icon>person_4</mat-icon>
                                <span i18n="@@organizer">Organizer</span>
                            </div>
                            <span class="normal">
                                <ng-container
                                    [ngTemplateOutlet]="staff"
                                    [ngTemplateOutletContext]="{
                                        staff: resource.organizers,
                                        icon: 'person_4'
                                    }"
                                ></ng-container>
                            </span>
                        </div>
                        <div *ngIf="resource.tags_attached" class="details-elem">
                            <div class="pre">
                                <mat-icon>label</mat-icon>
                                <span i18n="@@tags">Tags </span>
                            </div>
                            <span class="normal">
                                <mat-chip-list class="mt-1">
                                    <mat-chip
                                        *ngFor="let tag of resourceTags$ | async"
                                        (click)="showTagResources(tag)"
                                        class="res-chip-item tag-chip"
                                        ><span>{{ tag.name }}</span>
                                        <app-language-selector
                                            class="flag tag-chip-lang-select"
                                            fxFlex="0 0 auto"
                                            [language_id]="tag.language_id"
                                        >
                                        </app-language-selector
                                    ></mat-chip>
                                </mat-chip-list>
                            </span>
                        </div>
                        <div *ngIf="resourceCategories$ | async; let cats" class="details-elem">
                            <div class="pre">
                                <mat-icon>apps</mat-icon>
                                <span i18n="@@categories">Categories </span>
                            </div>
                            <span class="normal">
                                <mat-chip-list class="mt-1">
                                    <mat-chip
                                        class="res-chip-item cat-chip"
                                        *ngFor="let cat of cats"
                                        (click)="showCatgeoryResources(cat)"
                                        >{{ cat.title }}</mat-chip
                                    >
                                </mat-chip-list>
                            </span>
                        </div>
                        <div class="details-elem">
                            <div class="pre">
                                <mat-icon>timelapse</mat-icon>
                                <span i18n="@@duration">Duration </span>
                            </div>
                            <span class="normal">{{ resource?.duration | formatIsoDuration : false }} </span>
                        </div>
                        <div *ngIf="resource.time_limit" class="details-elem">
                            <div class="pre">
                                <mat-icon>timer</mat-icon>
                                <span i18n="@@playTime">Play time </span>
                            </div>
                            <span class="normal">{{ resource?.time_limit | formatIsoDuration }} </span>
                        </div>
                        <div *ngIf="resource.examination && resource.examination.label" class="details-elem">
                            <div class="pre">
                                <mat-icon>military_tech</mat-icon>
                                <span i18n="@@endReward">End reward </span>
                            </div>
                            <span class="normal">{{ resource.examination?.label }} </span>
                        </div>
                        <div *ngIf="resource.article_code" class="details-elem">
                            <div class="pre">
                                <mat-icon>center_focus_strong</mat-icon>
                                <span i18n>Event code</span>
                            </div>
                            <span class="normal">{{ resource.article_code }} </span>
                        </div>
                        <div *ngIf="resource.total_seats" class="details-elem">
                            <div class="pre">
                                <mat-icon>event_seat</mat-icon>
                                <span i18n>Available seats</span>
                            </div>
                            <span class="normal">
                                {{ resource.total_seats }}
                            </span>
                        </div>
                        <div *ngIf="resource.extra_seats" class="details-elem">
                            <div class="pre">
                                <mat-icon>weekend</mat-icon>
                                <span i18n>Extra seats</span>
                            </div>
                            <span class="normal">
                                {{ resource.extra_seats }}
                            </span>
                        </div>
                        <div class="details-elem">
                            <div class="pre">
                                <mat-icon>qr_code_scanner</mat-icon>
                                <span i18n>Qr code </span>
                            </div>
                            <ngx-qrcode qrc-element-type="url" [value]="qrCodeData"> </ngx-qrcode>
                        </div>
                        <div
                            *ngIf="resource.quote_ids"
                            class="details-elem pt-0 pb-0"
                            fxLayoutAlign="space-between center"
                            fxLayout="row"
                        >
                            <div class="pre">
                                <mat-icon>format_quote</mat-icon>
                                <span i18n="@@quotes">Quotes</span>
                            </div>
                            <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="normal">
                                <mat-slide-toggle (change)="toggleQuotes($event.checked)"></mat-slide-toggle>
                                <button class="quotes-show m-0" mat-icon-button (click)="showQuotesInSlide()">
                                    <mat-icon>view_list</mat-icon>
                                </button>
                            </span>
                        </div>
                        <div
                            *ngIf="user.role_value != 'guest'"
                            class="details-elem pt-0 pb-0"
                            fxLayoutAlign="space-between center"
                            fxLayout="row"
                        >
                            <div class="pre">
                                <mat-icon>history_toggle_off</mat-icon>
                                <span i18n>History</span>
                            </div>
                            <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="normal">
                                <button class="quotes-show m-0" mat-icon-button (click)="showResLog()">
                                    <mat-icon>touch_app</mat-icon>
                                </button>
                            </span>
                        </div>
                        <!-- <div
                            *ngIf="
                                resource.medias?.exercise &&
                                !!resource.medias.exercise.length &&
                                resource.opportunity_id
                            "
                            class="details-elem pt-0 pb-0"
                            fxLayoutAlign="space-between center"
                            fxLayout="row"
                        >
                            <div class="pre">
                                <mat-icon>topic</mat-icon>
                                <span i18n>Exercise documents</span>
                            </div>
                            <span
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="4px"
                                class="normal relative pl-0"
                            >
                                <span class="doc-count">{{ resource.medias.exercise.length }}</span>
                                <button
                                    class="quotes-show m-0"
                                    mat-icon-button
                                    (click)="download(resource.exercise_downloads)"
                                >
                                    <mat-icon>file_download</mat-icon>
                                </button>
                            </span>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #academyLogo>
    <ng-container *ngIf="resource.public">
        <img src="assets/images/KD_KOL_logo_long_white.png" alt="KlickData" />
    </ng-container>
    <ng-container *ngIf="!resource.public">
        <ng-container *ngIf="!!resource.publishers?.length">
            <app-image-view
                class="publisher-logo-img"
                [scope]="AppScope.RESOURCES"
                [media_id]="resource.publishers[0].media$"
                [proportional]="false"
            >
            </app-image-view>
        </ng-container>
    </ng-container>
</ng-template>
<ng-template #smallLoading>
    <app-kd-logo-loading class="small-load-header" size="small"></app-kd-logo-loading>
</ng-template>
<ng-template #staff let-staff="staff" let-icon="icon">
    <div class="member-wrapper" fxLayoutAlign="center center" fxLayout="column">
        <div fxFlex="row" fxLayoutAlign="start center" class="w-100" fxLayoutGap="10px">
            <ng-container *ngFor="let member of staff; let index = index">
                <ng-container *ngIf="index < 2">
                    <app-image-view
                        (click)="showManagers(staff)"
                        [ngClass]="{ 'img-comp': index === 1 }"
                        [scope]="AppScope.USERS"
                        [media_id]="member.media$"
                        [paddingBottom]="'62px'"
                    >
                    </app-image-view>
                </ng-container>
            </ng-container>
            <span class="remain-managers" (click)="showManagers(staff)" *ngIf="staff.length > 2"
                >+ {{ staff.length - 2 }}</span
            >
        </div>
        <div class="manager-name" (click)="showManagers(staff)">
            <span>{{ staff[0].name }}</span>
            <span *ngIf="staff.length > 1">&</span>
            <span *ngIf="staff.length > 1">{{ staff[1].name }}</span>
            <span *ngIf="staff.length > 2" i18n>& others</span>
        </div>
    </div>
</ng-template>

<ng-template #shareTemp let-resource="resource">
    <button
        *ngIf="!(shareLoading | async); else shareLoadTemp"
        class="grey"
        fxFlex="0 0 auto"
        matTooltip="Share"
        i18n-matTooltip="@@share"
        mat-icon-button
        (click)="shareService.openShareDialog(resource, shareLoading)"
    >
        <mat-icon>share</mat-icon>
    </button>
</ng-template>
<ng-template #inviteBtn let-resource="resource">
    <button
        class="green"
        matTooltip="Invite a friend"
        i18n-matTooltip
        (click)="invite(resource)"
        mat-icon-button
        fxFlex="0 0 auto"
    >
        <mat-icon>outgoing_mail</mat-icon>
    </button>
</ng-template>

<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
<ng-template #all_occasion_dates>
    <div
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
        class="dates-res-occasions"
        *ngFor="
            let occ of resource.user_collaboration.enroll_approval_required.metadata.occasion_dates;
            let index = index
        "
    >
        <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
            <ng-container *ngIf="occ.application_start_date && occ.application_end_date">
                <span>Application Open:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.application_start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>

                    <span i18n>To:</span>
                    <span>{{ occ.application_end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span>{{ resource.time_zone }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="occ.start_date && occ.end_date">
                <span>Course Starts:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>

                    <span i18n>To:</span>
                    <span>{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span>{{ resource.time_zone }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
